import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, CanActivateFn } from '@angular/router';
import { CustomLoginService } from '@privatelib/ngx18-authz-dev';
import { CVA_CONSTANTS } from '../../util/constants';
import { AUTH_MODULE_ROUTE_MAP } from '../../util/route.constants';

export const PermissionGuard: CanActivateFn = async(next: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const authorize = inject(CustomLoginService);
  const currentRoutePath = next.routeConfig?.path ?? '';
  const moduleForRoute = AUTH_MODULE_ROUTE_MAP[currentRoutePath ?? '/'];
  const isAuthorized =await authorize.IsAuthorized(moduleForRoute, CVA_CONSTANTS.PERMISSION.READ);
  if (!isAuthorized) {
    router.navigate(['/error']);
    return false;
  }
  return true;
};


